import React from 'react';
import { motion } from 'framer-motion';
const PRODUCT_IMAGES = ['https://cdn.magicpatterns.com/patterns/generated-images/681500df-95b8-48f0-8cac-7e637eca992d.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/681500df-95b8-48f0-8cac-7e637eca992d.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/681500df-95b8-48f0-8cac-7e637eca992d.jpg'];
export function ValueProp() {
  return <section className="w-full bg-white py-20" data-id="element-324" data-mp="vxbfy56lkz43">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 lg:grid-cols-2 lg:px-8" data-id="element-325" data-mp="vtw3790ec25u">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.6
      }} data-id="element-326" data-mp="mvkexdn05ggk">
          <h2 className="font-display text-4xl font-bold leading-tight text-ardis-blue sm:text-5xl" data-id="element-327" data-mp="2h9bipwinh643">
            Achetez plus
            <br data-id="element-328" data-mp="2cbjsr81kfu2j" />
            Payez moins !
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-gray-600" data-id="element-329" data-mp="r58j6sdk9j28">
            Avec une large gamme de produits — de l’alimentation à l’électronique — LE PIAN
            DISTRIBUTION vous accompagne dans tous vos approvisionnements. Des prix de gros négociés
            pour vous offrir le meilleur rapport qualité-prix, en toute confiance.
          </p>
          <a href="#categories" className="mt-8 inline-flex rounded-full bg-ardis-green px-7 py-3 font-display text-sm font-semibold text-white transition-colors hover:bg-ardis-green-dark" data-id="element-330" data-mp="n3x4hhw86i8t">
            Explorer les catégories
          </a>
        </motion.div>

        <div className="grid grid-cols-3 gap-4" data-id="element-331" data-mp="113671eriddub">
          {PRODUCT_IMAGES.map((src, i) => <motion.img key={i} src={src} alt="Produit électronique en promotion" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.12
        }} className="aspect-square w-full rounded-lg object-contain" data-id="element-332" data-mp="160yan61imoec" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}